// Shared click-ID reads for callback / lead-form payloads.
// Click IDs are stored as { value, expiryDate } records by footer.vue's capture.
// These helpers honour that expiry so a stale click never rides a fresh
// conversion — reading raw .value (the old pattern) ignored expiry and
// inflated paid attribution.

// Reads one stored click ID and checks it hasn't expired.
// Returns the value, or null if missing/expired/malformed.
// Side effect: removes the record if expired or unparseable (self-healing).
export function getStoredClickId(key) {
  try {
    const stored = JSON.parse(localStorage.getItem(key));
    if (stored && new Date().getTime() < stored.expiryDate) {
      return stored.value;
    }
    if (stored) localStorage.removeItem(key);
  } catch (e) {
    localStorage.removeItem(key);
  }
  return null;
}

// Returns all live (unexpired) click IDs, ready to spread onto a payload.
// gbraid/wbraid are Google's iOS/ATT alternatives to gclid — Google sends one
// INSTEAD of a gclid, never alongside, so all three have to be read.
export function getLiveClickIds() {
  const out = {};
  ['gclid', 'gbraid', 'wbraid', 'msclkid', 'fbclid', 'ttclid'].forEach((key) => {
    const value = getStoredClickId(key);
    if (value) out[key] = value;
  });
  return out;
}
